__turbopack_context__.v({
  "layer": "loadingRipples-module__kRaHrW__layer",
  "loadingRipplePulse": "loadingRipples-module__kRaHrW__loadingRipplePulse",
  "ring": "loadingRipples-module__kRaHrW__ring",
});
